import React from 'react'
import { func } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { productDataType } from 'models/propTypes'
import ProductItemDetail from 'components/designSidepanel/ProductItemDetail'
import ProductItemImage from 'components/designSidepanel/ProductItemImage'

require('./ProductItem.scss')

const ProductItem = ({ furnitureData, onSelect, addToRoom, viewDetails }) => {
    const { t } = useTranslation()
    const addToRoomHandler = (e) => {
        e.stopPropagation()
        addToRoom()
    }

    const { name, price, description, thumbUrl, stacks } = furnitureData
    const addToRoomButtonAriaLabel = `${t('design.add to room')} ${name} ${description}`
    const viewDetailsAriaLabel = `${t('aria.product details')} ${name} ${description}`
    return (
        <div className="ProductItem" onClick={onSelect}>
            <div className="itemImageContainer" onClick={addToRoomHandler} data-img-title={t('design.add to room')}>
                <button data-testid={!stacks ? 'product-item-image-btn' : ''} aria-label={addToRoomButtonAriaLabel}>
                    <ProductItemImage thumbUrl={thumbUrl} name={name} showIcon />
                </button>
            </div>
            <div className="itemDetailContainer" onClick={viewDetails} aria-label={viewDetailsAriaLabel}>
                <ProductItemDetail name={name} price={price} description={description} />
            </div>
        </div>
    )
}
ProductItem.propTypes = {
    furnitureData: productDataType.isRequired,
    onSelect: func.isRequired,
    addToRoom: func.isRequired,
    viewDetails: func.isRequired,
}

export default ProductItem
